<div class="container">
    <img
        alt="Guitar pick"
        class="guitarPick"
        src="../../assets/guitarPick.svg"
    />

    <div class="wrapper">
        <!-- HEADER -->
        <div class="headerContainer">
            <div class="logoWrapper">
                <img
                    class="controlant-logo"
                    src="../../assets/controlant-logo-color.svg"
                />
            </div>
        </div>

        <!-- CONTENT -->
        <div class="contentContainer">
            <div class="contentHeader">
                <h4 class="aaTitle loginTitle">Account Admin</h4>
                <h5 class="loginSubtitle" *ngIf="step === 'login'">Sign in to your account</h5>

                <!-- ERRORS -->
                <div class="auth0Error" *ngIf="auth0Error">
                <fa-icon class="auth0Error--icon" [icon]="faExclamationCircle"></fa-icon>
                    <div>
                        <span class="auth0Error--title">SSO login failed</span>
                        <div>
                            {{ auth0Error }}
                        </div>
                    </div>
                </div>

                <div class="subHeader" *ngIf="loggedOut">
                    <span >You have been logged out.</span>
                </div>

                <div class="subHeader errorStyles">
                    <span *ngIf="errorCode === errorCodes.TOKEN_EXPIRED"
                        >Your token has expired.</span
                    >
                    <span *ngIf="errorCode === errorCodes.TIMED_OUT"
                        >You have timed out due to inactivity.</span
                    >
                    <span *ngIf="loginFailed"
                        >Login was unsuccessful. Please verify your username and
                        password and try again.</span
                    >
                    <span *ngIf="mfaFailed"
                        >Incorrect MFA code. Please correct the code and try
                        again.</span
                    >
                    <span *ngIf="isLockedOut"
                        >Too many invalid attempts. The username
                        {{ usernameSubmitted }} has been locked out of the
                        system for 10 minutes. Further attempts at logging in
                        during this time are futile.</span
                    >
                </div>

                <form
                    name="login"
                    accept-charset="utf-8"
                    (ngSubmit)="attemptLogin()"
                    [formGroup]="loginForm"
                    novalidate
                    autocomplete="off"
                    *ngIf="step === 'login'"
                >
                    <div class="field">
                        <label for="username">Username</label>
                        <input
                            class="form-input-control"
                            [class.Error]="
                                loginForm
                                    .get('username')
                                    .hasError('required') &&
                                loginForm.get('username').touched
                            "
                            data-testid="username"
                            type="text"
                            formControlName="username"
                            id="username"
                            autocomplete="off"
                            placeholder="Username"
                        />
                    </div>

                    <div class="field">
                        <label for="password">Password</label>
                        <input
                            class="form-input-control"
                            [class.Error]="
                                loginForm
                                    .get('password')
                                    .hasError('required') &&
                                loginForm.get('password').touched
                            "
                            data-testid="password"
                            type="password"
                            formControlName="password"
                            id="password"
                            (blur)="passwordBlurred = true"
                            autocomplete="off"
                            placeholder="Password"
                        />
                    </div>

                    <div class="loginAction">
                        <button
                            class="aaButton loginButton"
                            data-testid="button-login"
                            type="submit"
                            [disabled]="loginSSOBusy"
                        >
                            {{ !loginBusy ? "Sign in" : "Loading..." }}
                        </button>
                    </div>


                </form>
                <!-- SSO login form -->
                <form
                    name="loginSSO"
                    class="loginSSO"
                    accept-charset="utf-8"
                    (ngSubmit)="attemptLoginWithAuth0()"
                    [formGroup]="loginForm"
                    *ngIf="step === 'login'"
                    novalidate
                    autocomplete="off"
                >
                    <div class="loginSplitter">or</div>
                    <div class="loginAction">
                        <button
                            data-testid="button-login-sso"
                            class="aaButton ssoLoginButton"
                            type="submit"
                            [disabled]="loginBusy"
                        >
                            {{!loginSSOBusy ? "Sign in with SSO" : "Loading..."}}
                        </button>
                    </div>

                </form>

                <form
                    name="mfaCode"
                    accept-charset="utf-8"
                    (ngSubmit)="attemptMfaLogin()"
                    [formGroup]="mfaForm"
                    novalidate
                    autocomplete="off"
                    *ngIf="step === 'mfa'"
                >
                    <div>
                        <span class="subHeader"
                            >We have just sent you a code via e-mail or SMS.
                            Please enter the code below to continue.</span
                        >
                    </div>

                    <div class="field">
                        <label for="mfaCode"
                            >Multi-Factor Authentication Code</label
                        >
                        <input
                            class="form-input-control"
                            type="text"
                            formControlName="mfaCode"
                            id="mfaCode"
                            autocomplete="off"
                            placeholder="Enter authentication code"
                        />
                        <!-- <div class="messageContainer">
                    <div class="error-msg" *ngIf="!mfaForm.get('mfaCode').valid && mfaForm.get('mfaCode').dirty">
                        <span *ngIf="mfaForm.get('mfaCode').hasError('required')">Username is required</span>
                        <span *ngIf="mfaForm.get('mfaCode').hasError('pattern')">Username is invalid</span>
                    </div>
                </div> -->
                    </div>

                    <button class="aaButton" type="submit" [disabled]="loginBusy">
                        {{ !loginBusy ? "Log in" : "Loading..." }}
                    </button>
                </form>
                <div class="troubleWrapper">
                    <p class="aaText login-help">
                        Trouble signing in?
                        <a
                            class="link"
                            href="{{ envBaseUrl }}/users/{{
                                username
                            }}%20/request-password-reset"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="password-reset-link"
                        >
                            Reset password
                        </a>
                        or contact
                        <a class="link" href="mailto:support@controlant.com"
                            >support@controlant.com</a
                        >
                    </p>
                </div>
            </div>
        </div>

        <!-- footer -->
        <div class="footerContainer">
            <div id="disclaimer">
                <p class="aaText">
                    By logging in, you agree to our
                    <span (click)="showTerms = !showTerms" class="terms">
                        terms and conditions</span
                    >.
                </p>
            </div>
            <div class="terms-modal" *ngIf="showTerms">
                <div class="terms-content">
                    <h3>Terms & conditions</h3>
                    <span class="close-dialog" (click)="showTerms = !showTerms"
                        ><fa-icon [icon]="faClose"></fa-icon
                    ></span>
                    <ul style="overflow-y: scroll">
                        <li>
                            He who wishes to lease or buy Controlant's system,
                            solutions and the service related commits to
                            undertake the terms and conditions stated in this
                            agreement and business terms.
                        </li>
                        <li>
                            Controlant.com
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://controlant.com/terms"
                                >Terms of Use</a
                            >,
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://controlant.com/privacy"
                                >Privacy Policy</a
                            >
                            and
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://controlant.com/cookies"
                                >Cookies and Tracking Notice</a
                            >
                            apply to your use of Supply Chain Monitoring web
                            interface.
                        </li>
                        <li>
                            Standard delivery time for service requests,
                            including requests for increase in number of
                            loggers, review of data, requests for calibration
                            and other comparable services, is no longer than 14
                            business days from the date of the request, unless
                            unpredictable complications arise. Standard delivery
                            time for requests on changes in registration in the
                            database system is no longer than 4 business days
                            unless unpredictable complications arise. Customer
                            is aware that delivery time can vary depending on
                            different shipment methods.
                        </li>
                        <li>
                            Customers are obliged to treat all leased equipment
                            belonging to Controlant properly, and are liable for
                            any damage that occurs and cannot be traced to
                            normal dissolution, as well as for any equipment
                            that is lost while in their possession. Use of
                            equipment shall be in accordance with the guidelines
                            following the equipment.
                        </li>
                        <li>
                            The users of Controlant's solutions are liable for
                            all valuables that are being monitored by utilizing
                            Controlant solutions.
                        </li>
                        <li>
                            Controlant seeks to maximize security and efficiency
                            of real time monitoring, but the Customer of the
                            service acknowledges that loss of data is possible
                            due to power failure, loss of internet connection,
                            equipment failure or of other unpredictable causes.
                        </li>
                        <li>
                            Controlant will try to solve problems that can occur
                            including e.g. range issues, implementation problems
                            etc. with the equipment and methods the company
                            possesses. The Customer still acknowledges that
                            situations can occur where conventional methods are
                            not enough without the purchase of additional
                            equipment or service.
                        </li>
                        <li>
                            Controlant is not liable or responsible for any
                            damage or cost that might be caused by late delivery
                            of the leased equipment when delivery is delayed
                            because of circumstances not concerning the company,
                            e.g. due to delays which might occur from producer
                            or possible delays at transportation companies.
                        </li>
                        <li>
                            The Customer shall examine the leased equipment
                            carefully upon delivery and notify Controlant if
                            there are any comments on the condition of the
                            leased equipment.
                        </li>
                        <li>
                            Controlant is not liable or responsible for any
                            consequential damages or costs that might occur from
                            damages on the Customer's valuables or the valuables
                            of others if this is caused by a failure in the
                            leased equipment or the wrong usage of the
                            equipment.
                        </li>
                        <li>
                            The leased equipment shall be delivered in good
                            condition when returned and not damaged considering
                            normal usage during the agreement period, otherwise
                            charges for damages become effective according to
                            the terms of the agreement.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
